import { TableCell, TableRow } from "@mui/material"
import { formatBytes } from "../utils/ByteConverter"

export const StoragePackDistribution = ({areaId, size}) => {
    return(
        <TableRow>
            <TableCell sx={{color: "black"}}>
                {areaId}
            </TableCell>
            <TableCell sx={{color: "black"}}>
                {formatBytes(size)}
            </TableCell>
        </TableRow>
    )
}